import { observer } from 'mobx-react';
import Counter from './Counter';

interface Props {
  utilized: number;
  total: number;
}

function CounterIcon({ utilized, total }: Props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Counter utilized={utilized} total={total} />
    </svg>
  );
}

export default observer(CounterIcon);
